import { ParsedUrlQuery } from 'querystring';
import { useRouter } from 'next/router';

function useQueryParams(): ParsedUrlQuery {
  const router = useRouter();
  return router.query;
}

export default useQueryParams;
